import { defineMessages } from 'react-intl';

const messages = defineMessages({
  returnToResidentProfile: {
    id: 'App.ResidentProfile.ResidentMoveOut.ReturnToResidentProfile',
    defaultMessage: 'Go Back to Residents Profile',
  },
  returnToTenantProfile: {
    id: 'App.ResidentProfile.ResidentMoveOut.ReturnToTenantProfile',
    defaultMessage: 'Go Back to Tenants Profile',
  },
  confirmTitle: {
    id: 'App.ResidentProfile.ResidentMoveOut.ConfirmTitle',
    defaultMessage:
      'Are You Sure You Want to Move This Resident Out of the Unit?',
  },
  confirmTitleTenant: {
    id: 'App.ResidentProfile.ResidentMoveOut.ConfirmTitleTenant',
    defaultMessage:
      'Are You Sure You Want to Move This Tenant Out of the Unit?',
  },
  unitNumber: {
    id: 'App.ResidentProfile.ResidentMoveOut.UnitNumber',
    defaultMessage: 'Unit Number',
  },
  moveOutDate: {
    id: 'App.ResidentProfile.ResidentMoveOut.MoveOutDate',
    defaultMessage: 'Confirm Move-Out Date',
  },
  stepsCompleted: {
    id: 'App.ResidentProfile.ResidentMoveOut.StepsCompleted',
    defaultMessage: 'Steps Completed',
  },
  noticeToVacateEntered: {
    id: 'App.ResidentProfile.ResidentMoveOut.NoticeToVacateEntered',
    defaultMessage: 'Notice to Vacate Entered',
  },
  entered: {
    id: 'App.ResidentProfile.ResidentMoveOut.Entered',
    defaultMessage: 'Entered',
  },
  moveOutActionsCompleted: {
    id: 'App.ResidentProfile.ResidentMoveOut.MoveOutActionsCompleted',
    defaultMessage: 'Move-Out Actions Completed',
  },
  paidAmountDue: {
    id: 'App.ResidentProfile.ResidentMoveOut.PaidAmountDue',
    defaultMessage: 'Resident Paid Amount Due at Move-Out',
  },
  paidAmountDueTenant: {
    id: 'App.ResidentProfile.ResidentMoveOut.PaidAmountDueTenant',
    defaultMessage: 'Tenant Paid Amount Due at Move-Out',
  },
  turnedInKeys: {
    id: 'App.ResidentProfile.ResidentMoveOut.TurnedInKeys',
    defaultMessage: 'Turned In Keys',
  },
  moveOutChecklistCompleted: {
    id: 'App.ResidentProfile.ResidentMoveOut.MoveOutChecklistCompleted',
    defaultMessage: 'Move-Out Checklist Completed',
  },
  cancel: {
    id: 'App.ResidentProfile.ResidentMoveOut.Cancel',
    defaultMessage: 'Cancel',
  },
  moveResidentOutOfThisUnit: {
    id: 'App.ResidentProfile.ResidentMoveOut.MoveResidentOutOfThisUnit',
    defaultMessage: 'Move Resident Out of this Unit',
  },
  moveTenantOutOfThisUnit: {
    id: 'App.ResidentProfile.ResidentMoveOut.MoveTenantOutOfThisUnit',
    defaultMessage: 'Move Tenant Out of this Unit',
  },
  invalidDateFormat: {
    id: 'App.ResidentProfile.ResidentMoveOut.InvalidDateFormat',
    defaultMessage: 'Invalid date format.',
  },
  invalidDateValue: {
    id: 'App.ResidentProfile.ResidentMoveOut.InvalidDateValue',
    defaultMessage: 'Invalid date value, must be in the past 30 days',
  },
  required: {
    id: 'App.ResidentProfile.ResidentMoveOut.required',
    defaultMessage: 'Required',
  },
  invalidProRatedCredit: {
    id: 'App.ResidentProfile.ResidentMoveOut.invalidProRatedCredit',
    defaultMessage: 'Invalid value format',
  },
  note: {
    id: 'App.ResidentProfile.ResidentMoveOut.Note',
    defaultMessage: 'Note',
  },
  proRateNote: {
    id: 'App.ResidentProfile.ResidentMoveOut.ProRateNote',
    defaultMessage:
      // eslint-disable-next-line max-len
      'If these charges are not correct, you can correct by (1) closing this screen and updating the Monthly Lease Charges or Credits on the Lease Data Tab or (2) reversing the charges/credits from the ledger after move-out. ',
  },
  proRateAmountDateNote: {
    id: 'App.ResidentProfile.ResidentMoveOut.ProRateAmountDateNote',
    defaultMessage: 'IMPORTANT: This date must be the actual date of move-out.',
  },
  proRateAmountsToLedgerHeader: {
    id: 'App.ResidentProfile.ResidentMoveOut.ProRateAmountsToLedgerHeader',
    defaultMessage: '{type} Amounts Posting to Ledger:',
  },
  proRate: {
    id: 'App.ResidentProfile.ResidentMoveOut.ProRate',
    defaultMessage: 'Prorate',
  },
  full: {
    id: 'App.ResidentProfile.ResidentMoveOut.Full',
    defaultMessage: 'Full',
  },
  roundProratedAmounts: {
    id: 'App.ResidentProfile.ResidentMoveOut.roundProratedAmounts',
    defaultMessage:
      'This property is configured to round prorated amounts to the nearest dollar.',
  },
  hasOpenCertificationWarning: {
    id: 'App.ResidentProfile.ResidentMoveOut.HasOpenCertificationWarning',
    defaultMessage:
      'There is an open certification. You must complete or cancel the certification in order to move-out ' +
      'the resident for accurate reporting purposes.',
  },
  certificationsOpen: {
    id: 'App.ResidentProfile.ResidentMoveOut.CertificationsOpen',
    defaultMessage: 'No Certifications in Progress',
  },
  certificationsOpenTooltip: {
    id: 'App.ResidentProfile.ResidentMoveOut.certificationsOpenTooltip',
    defaultMessage:
      'Open certifications must be closed, canceled, or completed before you can proceed with the move-out.',
  },
  grCertificationOpen: {
    id: 'App.ResidentProfile.ResidentMoveOut.GRCertificationOpen',
    defaultMessage: 'No Gross Rent Certifications in Progress',
  },
  grCertificationOpenTooltip: {
    id: 'App.ResidentProfile.ResidentMoveOut.grCertificationOpenTooltip',
    defaultMessage:
      'Open Gross Rent certifications must be closed, canceled, or completed before you can proceed with the move-out.',
  },
  canceledAtMoveOut: {
    id: 'App.ResidentProfile.ResidentMoveOut.CanceledAtMoveOut',
    defaultMessage: 'Canceled at Move Out Completion',
  },
  grCertificationWillCancelTooltip: {
    id: 'App.ResidentProfile.ResidentMoveOut.grCertificationWillCancelTooltip',
    defaultMessage:
      'The open Gross Rent Certification will be automatically canceled when ' +
      'this household is moved out because its effective date is after the ' +
      'move-out date.',
  },
  utilReimbAdjTooltip: {
    id: 'App.ResidentProfile.ResidentMoveOut.utilReimbAdjTooltip',
    defaultMessage:
      // eslint-disable-next-line max-len
      'If the accounting integration bill is unpaid, it will be reversed and a new bill will be created to reflect the prorated amount.',
  },
  completed: {
    id: 'App.ResidentProfile.ResidentMoveOut.Completed',
    defaultMessage: 'Completed',
  },
  notCompleted: {
    id: 'App.ResidentProfile.ResidentMoveOut.NotCompleted',
    defaultMessage: 'Not Completed',
  },
});

export default messages;
